import Modal from "../Modal/Modal";

const SideModal = ({
  children,
  position = "right",
  width = 500,
  ...rest
  // isSellMode = false,
}) => {
  return (
    <Modal
      backDropStyle={{ justifyContent: "flex-end" }}
      style={{
        height: "100vh",
        maxHeight: "100%",
        borderRadius: 0,
        padding: "10px 40px",
      }}
      position={position}
      width={width}
      {...rest}
    >
      {children}
    </Modal>
  );
};

export default SideModal;
